import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { BullHornVariantOutlineIcon } from '../../../../atoms/material-icons';
import { fetchAbsolutePath, fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import './stock-announcements.m.css';

const StockAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [currentPath, setCurrentPath] = useState('');

  const getAnnouncementsData = async () => {
    const stockId = fetchStockId();
    const pagePath = fetchAbsolutePath();
    const stockDetailsResponse = await fetch(`/next/feapi/stock/stock-details/${stockId}`);
    const stockDetailsData = await stockDetailsResponse.json();
    const stockArray = stockDetailsData?.filter(
      (stock) => stock?.STOCKID?.toString() === fetchStockId(),
    );
    const isinNumber = stockArray[0]?.ISIN;
    const response = await fetch(`/next/feapi/stock/announcements/${isinNumber}`);
    const data = await response.json();
    setAnnouncements(data?.data);
    setCurrentPath(pagePath);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getAnnouncementsData();
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getAnnouncementsData();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="main-announcements-container">
      <div styleName="header-title-container">
        <BullHornVariantOutlineIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">ANNOUNCEMENTS</h2>
      </div>
      {announcements?.length === 0 ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      ) : (
        <>
          <div styleName="announcements-container ">
            {announcements?.map((announcement, index) => (
              <a href={announcement?.link} key={index} target="_blank" rel="noreferrer">
                <div styleName="announcement-content">
                  <div styleName="source-container">
                    <span styleName="source">{announcement?.source}</span>
                  </div>
                  <h5 styleName="announcement-title">{announcement?.title}</h5>
                  <div styleName="summary">{announcement?.summary}</div>
                  <div styleName="announcement-date">
                    {moment(announcement?.updatedDate).format('DD-MMM-YYYY HH:mm')}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

StockAnnouncements.propTypes = {
  currentStock: PropTypes.object.isRequired,
};

export default StockAnnouncements;
